import { db } from '@/config'

const bannersRef = function () {
  const now = new Date().getTime()
  return db.collection('banners').where('date_start', '<=', now)
}

export default {
  state: {
    banners: null
  },
  mutations: {
    setBanners (state, payload) {
      state.banners = payload
      if (payload) {
        localStorage.setItem('banners', JSON.stringify(payload.map(i => {
          const {
            action_type,
            date_end,
            date_start,
            id,
            image,
            image_2,
            media,
            order
          } = i;
          return {
            action_type,
            date_end,
            date_start,
            id,
            image,
            image_2,
            media,
            order
          }
        })))
      }
    }
  },
  actions: {
    async logBanner ({ commit, state, dispatch }, id) {
      const touch = {
        date: new Date().getTime(),
        banner_id: id,
        user_id: state.user ? state.user.uid : ''
      }
      dispatch('log_banner', { event: 'opens', banner_id: id }, { root: true })
      return false && db.collection('log_banner_views').add(touch)
    },
    getBanners ({ commit }) {
      commit('setBanners', JSON.parse(localStorage.getItem('banners')) || [] )
      bannersRef().onSnapshot(snap => {
        commit('setBanners', snap.docs.map(i => ({ id: i.id, ...i.data() })))
      })
    }
  },
  getters: {
    banners: (state) => {
      const now = new Date().getTime()
      return (state.banners || [])
        .filter(i => i.date_end > now)
        .sort((a, b) => a.order - b.order)
    }
  }
}
